module.exports = __webpack_public_path__ + "static/preview.714d7529.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/stephan/skelware/savot/public/images/preview.jpg
// module id = 496
// module chunks = 0 1